
import { IScrollDirection, scrollAnimation } from '@/tools/animation'
import { nextTick } from 'process'
import {
  computed,
  defineComponent,
  PropType,
  ref,
  onMounted,
  watch,
  onUnmounted
} from 'vue'
import { useStore } from 'vuex'

export interface ITabList {
  name: string;
  value: string;
  width?: number;
}

export default defineComponent({
  props: {
    lists: {
      type: Array as PropType<ITabList[]>,
      required: true
    },
    active: {
      type: String as PropType<string>,
      required: true
    },
    asyncLoaded: {
      type: Boolean
    }
  },

  emits: ['update:active', 'change'],

  setup (props, { emit }) {
    const store = useStore()

    const setActive = computed({
      get () {
        return props.active
      },
      set (val: string) {
        emit('update:active', val)
        emit('change')
      }
    })

    const tabMobileScroll = ref(0)
    const tabMobileScrollMax = ref(0)
    const tabCommonContainerRef = ref()

    function tabMobileScrollHandler (direction: IScrollDirection) {
      scrollAnimation({
        dom: tabCommonContainerRef.value,
        scroll: window.innerWidth,
        direction: direction
      })
    }

    const tabCommonMainRef = ref()

    /* 点亮的tab */
    const activeIndex = computed(() => {
      return props.lists.findIndex((list) => list.value === props.active)
    })

    /* 滑块样式 */
    const setSliderStyle = ref({
      width: '0px',
      transform: 'translateX(0px)'
    })

    /* tab选项修改事件 */
    function tabChangeHandler () {
      nextTick(() => {
        const childDom = tabCommonMainRef.value.children

        let sliderDuration = 0

        for (let i = 0; i <= activeIndex.value - 1; i++) {
          sliderDuration += childDom[i].clientWidth
        }

        setSliderStyle.value.width =
          childDom[activeIndex.value].clientWidth + 'px'
        setSliderStyle.value.transform =
        `translateX(${
          sliderDuration + activeIndex.value * 4
        }px)`
      })
    }

    /* 监听字体加载完成后，重新获取滑块样式 */
    watch(
      () => store.state.fontsReady,
      () => tabChangeHandler()
    )

    /* 监听异步数据加载完成 */
    watch(
      () => props.asyncLoaded,
      () => tabChangeHandler()
    )

    /* 监听active改变 */
    watch(
      () => props.active,
      () => tabChangeHandler()
    )

    /* tab初始化函数 */
    function tabInit () {
      // 可滚动最大值
      tabMobileScrollMax.value =
        tabCommonContainerRef.value.scrollWidth - window.innerWidth

      tabChangeHandler()
    }

    onMounted(() => {
      tabCommonContainerRef.value.onscroll = (evt: Event) => {
        const target = evt.target as HTMLDivElement

        // 保存滚动距离
        tabMobileScroll.value = target.scrollLeft
      }

      tabInit()

      window.addEventListener('resize', tabInit, false)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', tabInit, false)

      console.log('tab unmounted')
    })

    return {
      setActive,
      setSliderStyle,
      tabMobileScroll,
      tabMobileScrollMax,
      tabMobileScrollHandler,
      tabCommonContainerRef,
      tabCommonMainRef,
      tabChangeHandler
    }
  }
})
